// Externe Bibliotheken
import React, { Component } from 'react';

// Komponenten
import ProgressBar from './ProgressBar/';

class LoadingOffersBar extends Component {
    render() {
        return (
            <div className="loading-offers">
                <hr />
                <div className="headline" dangerouslySetInnerHTML={{ __html: window.$content.loadingOffersText }}></div>

                <ProgressBar finish={this.props.hasResult} finishText={'Ergebnisse werden aufbereitet ...'} />
            </div>
        );
    }
}

export default LoadingOffersBar;
